/* eslint-disable import/prefer-default-export */
import { FieldFunctionOptions, FieldPolicy, Reference } from '@apollo/client'

import { TestimonialsFilterInput } from '~generated/types'

type PaginatedTestimonialsCacheObj = {
  docs?: Reference[]
  limit?: number
  page?: number
  totalDocs?: number
  totalPages?: number
}

type Existing = PaginatedTestimonialsCacheObj
type Incoming = PaginatedTestimonialsCacheObj

export function createPaginatedTestimonialsQueryCache(): FieldPolicy<Existing, Incoming> {
  return {
    keyArgs: () => {
      const filterKeysDict: KeysEnum<TestimonialsFilterInput> = {
        tagIds: true,
        query: true,
      }

      return ['filter', Object.keys(filterKeysDict)]
    },

    merge: (_existing: Existing, incoming: Incoming) => {
      return incoming
    },

    read: (existing: Existing, _options: FieldFunctionOptions) => {
      if (!existing) return undefined

      return existing
    },
  }
}
